export const CompatibleProducts = Object.freeze({
  JIRA: 'JIRA',
  CONFLUENCE: 'CONFLUENCE',
  CRUCIBLE: 'CRUCIBLE',
  BAMBOO: 'BAMBOO',
  CROWD: 'CROWD',
  BITBUCKET: 'BITBUCKET',
  OPSGENIE: 'OPSGENIE',
  STATUS_PAGE: 'STATUS_PAGE',
  TOWNSQUARE: 'TOWNSQUARE'
});
export const CompatibleProductId = Object.freeze({
  Jira: 'jira',
  Confluence: 'confluence',
  Crucible: 'crucible',
  Bamboo: 'bamboo',
  Crowd: 'crowd',
  Bitbucket: 'bitbucket',
  Opsgenie: 'opsgenie',
  StatusPage: 'status_page',
  Townsquare: 'townsquare',
  Hipchat: 'hipchat'
});